<template>
  <div
    class="pointer-events-auto z-[1] flex cursor-wait items-center justify-around"
  >
    <IconLoading
      class="size-6 animate-spin text-primary"
      :class="spinnerClass"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  spinnerClass: {
    type: String,
    default: "",
  },
})
</script>
